import { createDialog } from '@edge/spark/feature-dialog'
import {
    MutationResolvers,
    PushToAmsUsingAssetIdArrayDocument as multiMutation,
    PushToAmsUsingAssetIdArrayMutation,
    PushToAmsUsingAssetIdDocument as singleMutation,
    PushToAmsUsingAssetIdMutation,
    PendingSuccess,
} from '../../../../generated/graphql'

import filterMaybe from '../../../../utils/filterMaybe'

const pushToAMS: MutationResolvers['pushToAMS'] = async (_root, { ids }, { client }) => {
    if (!client) {
        throw new Error('Missing ApolloClient context')
    }

    const single = ids.length === 1
    const mutation = single ? singleMutation : multiMutation
    const loadingMessage = single ? 'Sending vehicle to AMS…' : `Sending ${ids.length} vehicles to AMS…`

    createDialog({
        message: loadingMessage,
    })

    if (single) {
        const { data } = await client.mutate<PushToAmsUsingAssetIdMutation>({
            mutation,
            variables: { id: ids[0] },
        })

        const { success, stockNumber, message } = data?.pushVehicleToAms || {}
        const results = [
            {
                __typename: 'pushToAMSResposeResult' as const,
                success: success ? PendingSuccess.True : PendingSuccess.False,
                id: String(stockNumber),
            },
        ]

        const dialogMessage = success
            ? 'Successfully sent to AMS. Changes will update in Spark in a few minutes.'
            : message || 'Failed to send to AMS'

        createDialog({
            message: dialogMessage,
            timeout: success ? 5000 : 10000,
        })

        return {
            __typename: 'pushToAMSResponse',
            results,
        }
    }

    const { data } = await client.mutate<PushToAmsUsingAssetIdArrayMutation>({
        mutation: multiMutation,
        variables: { ids },
    })

    const results =
        data?.pushVehiclesToAms?.results?.filter(filterMaybe).map(({ id, isPossible }) => ({
            __typename: 'pushToAMSResposeResult' as const,
            id,
            success: isPossible ? PendingSuccess.Pending : PendingSuccess.False,
        })) || []

    const total = results.length
    const failedCount = results.filter((r) => r.success === PendingSuccess.False).length

    const resultMessage =
        failedCount > 0
            ? `${failedCount} of ${total} failed to be sent to AMS.`
            : 'Successfully sent to AMS. Changes will update in Spark in a few minutes.'

    createDialog({
        message: resultMessage,
        timeout: 5000,
    })

    return {
        __typename: 'pushToAMSResponse',
        results,
    }
}

export default pushToAMS
